import BoldText from '@/components/BoldText'
import RegularText from '@/components/RegularText'
import { handleSaveLocationSettings, locationSettingSelector } from '@/redux/slice/location.slice'
import { handleSetSaveBar } from '@/redux/slice/savebar.slice'
import { BlockStack, Card, Checkbox, Layout } from '@shopify/polaris'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

const CustomerOptions = () => {
  const { t } = useTranslation('locations')
  const dispatch = useDispatch()
  const locationSettings = useSelector(locationSettingSelector)

  const handleChangeCustomerOptions = (checked: boolean, id: string) => {
    dispatch(handleSetSaveBar({ isShowSaveBar: true }))
    dispatch(handleSaveLocationSettings({ [id]: checked }))
  }

  return (
    <div className="ot-location-customer-option">
      <Layout>
        <Layout.Section variant="oneThird">
          <BoldText>
            {t('addEditLocation.customerOptions')}
          </BoldText>
          <RegularText>{t('addEditLocation.customerOptionsDesc')}</RegularText>
        </Layout.Section>
        <Layout.Section>
          <Card>
            <BlockStack gap={'400'}>
              <Checkbox
                label={t('addEditLocation.turnOnPickup')}
                id="isEnablePickup"
                checked={locationSettings.isEnablePickup}
                onChange={handleChangeCustomerOptions}
              />
              <Checkbox
                label={t('addEditLocation.turnOnDelivery')}
                id="isEnableDelivery"
                checked={locationSettings.isEnableDelivery}
                onChange={handleChangeCustomerOptions}
              />
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </div>
  )
}

export default CustomerOptions
